<template>
  <div class="family-buttons">
    <div v-if="title" class="family-buttons__title">{{ title }}</div>
    <div class="family-buttons__buttons">
      <label
        class="family-buttons__button btn-calc"
        :class="count === 1 ? 'btn-calc_primary' : 'btn-calc_outline'"
      >
        <input v-model="count" :value="1" type="radio" @change="handleRadio" />👩‍ 👨</label
      >
      <label
        class="family-buttons__button btn-calc"
        :class="count === 2 ? 'btn-calc_primary' : 'btn-calc_outline'"
      >
        <input v-model="count" :value="2" type="radio" @change="handleRadio" />👩‍ 👨 👶</label
      >
      <label
        class="family-buttons__button btn-calc"
        :class="count === 3 ? 'btn-calc_primary' : 'btn-calc_outline'"
      >
        <input v-model="count" :value="3" type="radio" @change="handleRadio" />👩‍ 👨 👧 👶 +</label
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "FamilyButtons",
  props: {
    title: {
      type: String,
    },
    value: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      count: this.value,
    };
  },
  watch: {
    value(val) {
      this.count = val;
    },
  },
  methods: {
    handleRadio(e) {
      this.$emit("input", +e.target.value);
      this.$emit("change-count", +e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
input[type="radio"] {
  position: fixed;
  width: 0;
  opacity: 0;
}

.family-buttons {
  flex: 1;
  margin-bottom: 38px;

  &__title {
    margin-bottom: 18px;
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;

    text-align: left;
  }

  &__buttons {
    display: flex;
    justify-content: space-between;
    gap: 12px;
  }

  .btn-calc {
    position: relative;
    overflow: hidden;
    border: none;
    border-radius: 12px;
    padding: 8px 16px;
    font-weight: 500;
    font-size: 26px;
    line-height: 35px;
    transition: background 400ms;
    cursor: pointer;

    &_secondary {
      color: #2771fc;
      background-color: #fff;
    }

    &_outline {
      border: 1px solid #c1d3e3;
      font-weight: 400;
      color: #252628;
      background-color: transparent;
    }

    &_primary,
    &_active {
      box-shadow: 2px 6px 16px rgba(60, 102, 210, 0.39);
      color: #fff;
      background-color: #2771fc;
    }
  }

  span.ripple {
    position: absolute;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.7);
    transform: scale(0);
    animation: ripple 600ms linear;
  }

  @keyframes ripple {
    to {
      opacity: 0;
      transform: scale(4);
    }
  }
}

@media screen and (max-width: 768px) {
  .family-buttons {
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;

    &__title {
      margin-bottom: 16px;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
    }

    &__buttons {
      max-width: 244px;
      gap: 8px;
    }

    .btn-calc {
      padding: 4px 8px;
      font-size: 12px;
      line-height: 24px;
    }
  }
}
</style>
